import React from 'react';
import PropTypes from 'prop-types';
import {
  ComponentWrapper, ComponentVerticalSpacing, CardSlider, Svg, Card, COLORS, CARD_SLIDER_TYPES
} from 'day8-react/build/new-components';

const Accomodation = ({ accomodation: { items, images, title } }) => (
  <ComponentVerticalSpacing className="tsw-c-accomodation d8-u-bg-img">
    <ComponentWrapper>
      <h2 className="text-center margin-bottom-xl">{title}</h2>
      <div className="grid gid-gap-lg">
        <div className="col-4@sm self-center">
          {items && items.map((item, i) => (
            <div key={i} className="flex items-center margin-y-md">
              <div className="icon__wrapper icon icon--lg flex flex-center d8-u-radius-full d8-u-primary-bg-lower-bg margin-right-sm"><Svg className="icon--md" name={item.icon || 'checkmark'} fill={COLORS.PRIMARY} /></div>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
        <div className="col-8@sm">
          <CardSlider type={CARD_SLIDER_TYPES.NON_FULL_WIDTH} parentOffset={20}>
            {images.map(({ image }, i) => <Card key={i} template="ImageCard" size="xl" bgImage={{ url: image, alt: title }} />)}
          </CardSlider>
        </div>
      </div>
    </ComponentWrapper>
  </ComponentVerticalSpacing>
);

Accomodation.propTypes = {
  accomodation: PropTypes.object
};

export default Accomodation;
